import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const IntegrationsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Integrations",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.65 8.54 16.62 2.18c-.18-.11-.4-.17-.64-.17s-.45.06-.64.17L4.31 8.54c-.37.23-.62.63-.62 1.1v12.73c0 .47.25.88.63 1.1l11.03 6.37c.18.11.4.17.64.17s.45-.06.64-.17l11.03-6.36c.38-.23.63-.63.64-1.1V9.65c0-.47-.26-.88-.65-1.1ZM15.99 4.75l8.48 4.9-8.48 4.9-8.48-4.9zm-9.75 7.1 8.48 4.9v9.78l-8.48-4.9zm11.03 14.68v-9.78l8.47-4.9v9.78z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.43 29h-8c-.63 0-1.14-.51-1.14-1.14v-2.29c0-1.26-1.03-2.29-2.29-2.29s-2.29 1.03-2.29 2.29v2.29c0 .63-.51 1.14-1.14 1.14h-8c-.63 0-1.14-.51-1.14-1.14V21C2.91 21 .86 18.95.86 16.43s2.05-4.57 4.57-4.57V5c0-.63.51-1.14 1.14-1.14h22.86c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14h-2.29c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29h2.29c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14m-6.86-2.29h5.71V21h-1.14c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57h1.14V6.15H7.71v6.86c0 .63-.51 1.14-1.14 1.14H5.43c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29h1.14c.63 0 1.14.51 1.14 1.14v6.86h5.71v-1.14c0-2.52 2.05-4.57 4.57-4.57s4.57 2.05 4.57 4.57v1.14Z"
      })
    })
  }));
};